module.exports = __webpack_public_path__ + "media/images/vandaaginhuis-6a61cecf376ac3623133a9b2ffc43348.png";